import React, { useState } from "react"
import { connect } from "react-redux"
import { Tooltip } from "@material-ui/core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCompass } from "@fortawesome/free-solid-svg-icons"
import { Modal, Tab, Tabs } from "react-bootstrap"
import { selectNewAreaDispatchAction } from "../../../state/geoMap/dispatchActions"
import { getSyncSearchFormValuesByState } from "../../../helpers/configurationHelper"
import { ConfigurationsType } from "../../../types/configurations"
import { ShapeType } from "../../../types/shape"
import { DEFAULT_TOOLTIP_PROPS } from "../../../helpers/tooltipHelper"
import translations from "../../../translations"
import CircleAOIHelper from "./CircleAOIHelper"
import KMLAOIHelper from "./KMLAOIHelper"
import GeoJsonAOIHelper from "./GeoJsonAOIHelper"
import SquareAOIHelper from "./SquareAOIHelper"
import {SearchResultsType} from "../../../types/product";

interface PropsType {
  configurations: ConfigurationsType,
  selectedArea: ShapeType,
  values: any,
  updatePathCoordinatesActionHandler: any,
  language: string,
  selectNewAreaDispatchActionHandler: any,
  searchByProducts: boolean,
  searchResults: SearchResultsType
}

const ManualAOIHelper = (props: PropsType) => {
  const { language, searchByProducts, searchResults } = props

  const [showModal, setShowModal] = useState(false)
  const handleCloseModal = () => setShowModal(false)
  const handleShowModal = () => setShowModal(true)
  const [key, setKey] = useState("bbox")

  return (
    <div className="path-importer-container">
      <Tooltip
        {...DEFAULT_TOOLTIP_PROPS}
        title={translations("coordinatesInjection", language)}
        placement="bottom"
      >
        <div>
          <FontAwesomeIcon
            className="path-file-importer-icon fa-lg"
            icon={faCompass}
            onClick={(event) => {
              event.preventDefault()
              // event.stopPropagation();
              handleShowModal()
            }}
          />
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            animation
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              {translations("coordinatesInjection", language)}
            </Modal.Header>
            <Modal.Body>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
              >
                <Tab
                  eventKey="bbox"
                  title={translations("roundingBoxButtonModal", language)}
                >
                  <SquareAOIHelper handleCloseModal={handleCloseModal} />
                </Tab>
                <Tab
                  eventKey="circle"
                  title={translations("circleButtonModal", language)}
                >
                  <CircleAOIHelper handleCloseModal={handleCloseModal} />
                </Tab>
                <Tab
                  eventKey="kml"
                  title={translations("KMLButtonModal", language)}
                >
                  <KMLAOIHelper handleCloseModal={handleCloseModal} />
                </Tab>
                <Tab
                  eventKey="geoJson"
                  title={translations("geoJsonButtonModal", language)}
                >
                  <GeoJsonAOIHelper handleCloseModal={handleCloseModal} />
                </Tab>
              </Tabs>
            </Modal.Body>
          </Modal>
        </div>
      </Tooltip>
    </div>
  )
}

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  values: getSyncSearchFormValuesByState(state),
  language: state.application.appParameters.language,
  searchByProducts: state.geoMap.searchByProducts,
  searchResults: state.product.searchResults
})

const mapDispatchToProps = (dispatch) => ({
  selectNewAreaDispatchActionHandler: (
    configurations,
    appParameters,
    scopeFields,
    formValues,
    newShape,
    language,
    searchByProducts,
    searchResults
  ) => dispatch(
    selectNewAreaDispatchAction(
      configurations,
      appParameters,
      scopeFields,
      formValues,
      newShape,
      language,
      searchByProducts,
      searchResults
    )
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(ManualAOIHelper)
